/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Also_AvailableInputs */

const en_downloads_also_available = /** @type {(inputs: Downloads_Also_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Also available on`)
};

const es_downloads_also_available = /** @type {(inputs: Downloads_Also_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`También disponible en`)
};

/**
* | output |
* | --- |
* | "Also available on" |
*
* @param {Downloads_Also_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_also_available = /** @type {((inputs?: Downloads_Also_AvailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Also_AvailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_also_available(inputs)
	return en_downloads_also_available(inputs)
});